'use strict';

var widgetId = require('shared/widgetId'),

    busyWidgets = {};

module.exports = {
    setBusy: setBusy,
    setFree: setFree,
    isBusy: isBusy,
    isBusyWithMessage: isBusyWithMessage
};

// TODO: create unit tests
function setBusy(widgetId, processedMsgId) {

    _validateWidgetId(widgetId);

    busyWidgets[widgetId] = processedMsgId;
}

function setFree(widgetId, processedMsgId) {

    _validateWidgetId(widgetId);

    if (busyWidgets[widgetId] && busyWidgets[widgetId] === processedMsgId) {
        delete busyWidgets[widgetId];
    }
}

function isBusy(widgetId) {

    _validateWidgetId(widgetId);

    return busyWidgets.hasOwnProperty(widgetId);
}

function isBusyWithMessage(widgetId, messageId) {

    _validateWidgetId(widgetId);

    return busyWidgets.hasOwnProperty(widgetId) ? busyWidgets[widgetId] === messageId : false;
}

function _validateWidgetId(validationSubject) {
    if (!widgetId.isValid(validationSubject)) {
        throw new Error('iVis.Widget: widgetBusyState methods expect a valid widgetId');
    }
}



//////////////////
// WEBPACK FOOTER
// ./src/widget/scripts/lib/commons/widgetStateManager.js
// module id = 6
// module chunks = 0 1